export default class ProductData {
    static getDefaultProductData() {

        return {
            id: '',
            name: '',
            group_id: '',
            description: '',
            meta_description: '',
            quantity_pack: '',
            barcode: '',
            quantity: '',
            price: '',
            unit: '',
            type_id: '',
            warehouse_id: '',
            manufacturer_id: '',
            comment: '',
            site_on: '',
            code: '',
            status: '',
            user_id: '',
            suitability: '2022-10-12',
        }
    }

}
